import React, {useEffect, useState} from 'react'
import {useAlert} from "react-alert";
import {Dropdown, Spinner} from 'react-bootstrap'
import {getMessageConfigListComboBox, searchProcessByDinamicFilter, sendMessage} from '../../services/RequestService';
import DataTableDinamicFilter from '../../genericComponents/datatable/DataTableDinamicFilter';
import {masks} from "../../utils/index";

export default function MessageSender() {
  const alert = useAlert();
  const [loading, setLoading] = useState(false)
  const [templates, setTemplates] = useState(null);
  const [selectedProcess, setSelectedProcess] = useState([]);

  const filter = [
    { key: 'id', label: 'ID Processo', type: 'number' },
    { key: 'processType.name', label: 'Tipo do Processo', type: 'text' },
    { key: 'processStatus.name', label: 'Situação do Processo', type: 'text' },
    { key: 'customer.id', label: 'ID Cliente', type: 'number' },
    { key: 'customer.fullname', label: 'Nome', type: 'text' },
    { key: 'customer.cpf', label: 'CPF', type: 'text' },
    { key: 'customer.birthday', label: 'Data Nascimento', type: 'text' },
    { key: 'customer.email', label: 'E-Mail', type: 'text' },
    { key: 'customer.phone', label: 'Telefone', type: 'text' },
    { key: 'customer.contactWay', label: 'Tipo de Contato', type: 'text' },
    { key: 'deliveryDate', label: 'Prazo de Entrega', type: 'date' },
    { key: 'doneDate', label: 'Entrega do Processo', type: 'date' },
    { key: 'createDate', label: 'Criação do Processo', type: 'date' },
    { key: 'pausedDate', label: 'Processo Pausado em', type: 'date' },
    { key: 'done', label: 'Processo Finalizado', type: 'boolean' },
    { key: 'paused', label: 'Processo Pausado', type: 'boolean' },
    { key: 'payment.amount', label: 'Valor', type: 'number' },
    { key: 'payment.rmiSimulada', label: 'RMI Simulada', type: 'number' },
    { key: 'payment.rmiConcedida', label: 'RMI Concedida', type: 'number' },
    { key: 'payment.complementoPositivo', label: 'Complemento Positivo', type: 'number' },
    { key: 'selectedPaymentType', label: 'Tipo de Pagamento', type: 'text' }
  ]

  const columns = [
    { label: "ID Cliente", prop: "idCliente" },
    { label: "Nome", prop: "nome" },
    { label: "ID Processo", prop: "idProcesso" },
    { label: "Tese", prop: "tipoProcesso" },
    { label: "Status Processo", prop: "statusProcesso" },
    { label: "Nascimento", prop: "aniversario" },
    { label: "Prazo Entrega", prop: "dataEntrega", render: (r) => masks.convertDateToBr(r.dataEntrega) },
    { label: "Pausado?", prop: "processoPausado" },
    { label: "Data Pausa", prop: "dataPausaProcesso", render: (r) => masks.convertDateToBr(r.dataPausaProcesso) },
    { label: "Aberto?", prop: "processoFinalizado" },
    { label: "Honorários", prop: "valorPagamento", render: (r) => masks.money(r.valorPagamento) },
    { label: "Tipo Pagamento", prop: "tipoPagamento" },
    { label: "Criado em", prop: "dataCriacaoProcesso", render: (r) => masks.convertDateToBr(r.dataCriacaoProcesso) },
    { label: "Telefone", prop: "telefone" },
    { label: "E-mail", prop: "email" },
    { label: "Tipo de Contato", prop: "tipoContato" }
  ];

  useEffect(() => {
    if (templates === null) {
      getMessageConfigListComboBox().then(({ data, ok }) => {
        if (ok) setTemplates(data)
      })
    }
  }, [templates, setTemplates]);

  function send(templateId) {
    setLoading(true)
    sendMessage(selectedProcess, templateId).then(({ ok, data }) => {
      if (ok) alert.success('Mensagens enviadas com sucesso!');
      else alert.error('Erro ao enviar mensagens, ' + data?.log);
      setLoading(false)
    })
  }

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <DataTableDinamicFilter
        pageTile={"Enviar Mensagens"}
        fields={filter}
        ajaxData={searchProcessByDinamicFilter}
        columns={columns}
        onSelect={setSelectedProcess}
        actions={
          window.innerWidth > 768 && (
            <Dropdown className="ml-2">
              <Dropdown.Toggle variant="primary" id="dropdown-templates">
                Enviar
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(templates || []).map((temp, idx) => (
                  <Dropdown.Item
                    key={idx}
                    disabled={selectedProcess.length === 0}
                    onClick={() => send(temp.value.toString())}
                  >
                    {temp.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )
        }
      />
    </div>
  );
}
